import { makeStyles } from 'tss-react/mui';
import { spacing, colors } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => ({
    mediaGalleryCard: {
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        borderRadius: theme.isFlyingFlowers ? '0px' : undefined,
        boxShadow: 'none',
        height: 'auto',
        margin: '0 !important',
        minHeight: 'auto',
        maxHeight: '364px',
        [theme.breakpoints.up('sm')]: {
            maxHeight: '352px',
        },
        [theme.breakpoints.up('md')]: {
            margin: 0,
            maxHeight: '372px',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '536px',
            maxHeight: '460px',
        },
        cursor: 'pointer',
    },
    mediaImageContainer: {
        width: '100%',
        position: 'relative',
        height: '184px',
        [theme.breakpoints.up('sm')]: {
            height: '172px',
        },
        [theme.breakpoints.up('md')]: {
            height: '168px !important',
        },
        [theme.breakpoints.up('lg')]: {
            height: '216px !important',
        },
        [theme.breakpoints.up('xl')]: {
            height: '288px !important',
        },
        '& > span:first-child': {
            width: '100% !important',
            height: '100% !important',
        },
        '& img': {
            height: '184px',
            [theme.breakpoints.up('sm')]: {
                height: '172px',
            },
            [theme.breakpoints.up('md')]: {
                height: '168px !important',
            },
            [theme.breakpoints.up('lg')]: {
                height: '216px !important',
            },
            [theme.breakpoints.up('xl')]: {
                height: '288px !important',
            },
        },
    },
    imageContainer: {
        objectFit: 'cover',
    },
    // Applied alongside mediaImageContainer for all video items.
    // display:flex centres the portrait pillarbox thumbnail horizontally.
    videoMediaImageContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& img': {
            height: '100% !important', //making the pillarbox thumbnail fill the height of the container, allowing blurred bg to show on left and right
        },
    },
    // Blurred backdrop — always rendered, hidden for landscape, visible for portrait (mirrors Video.tsx)
    portraitBlurredBg: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        overflow: 'hidden',
        visibility: 'hidden',
        backgroundColor: colors.supplementary.black,
        '& img': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(20px) brightness(0.7)',
            scale: '1.1',
        },
    },
    // Modifier: makes the blurred bg visible for portrait videos
    portraitBlurredBgVisible: {
        visibility: 'visible',
    },
    // Portrait 9:16 thumbnail — objectFit:contain so blurred bg shows on left/right sides
    portraitThumbnail: {
        position: 'relative',
        zIndex: 1,
        width: '100%',
        height: '100% !important',
        objectFit: 'contain',
        objectPosition: 'center',
        display: 'block',
    },
    // Landscape/thumbnail-provided video — fills the container cleanly
    videoThumbnail: {
        position: 'relative',
        zIndex: 1,
        width: '100%',
        height: '100% !important', // to override mediaImageContainer height restrictions
        objectFit: 'cover',
        objectPosition: 'center',
        display: 'block',
    },
    textContent: {
        padding: `12px 12px ${spacing.small} 12px`,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
    mediaGalleryContainer: {
        height: '100%',
        placeContent: 'unset',
        flexDirection: 'column',
    },
    mediaContentInner: {
        margin: 0,
        padding: '16px',
        alignSelf: 'start',
    },
    mediaHeading: Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.medium_bold_sm),
    description: Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.small_regular_sm), { color: colors.grey.grey6 }),
    icon: {
        fontSize: `100px`,
    },
    controlsContainer: {
        backgroundColor: 'transparent',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2,
        [`& .${classes.icon}`]: {
            fontSize: '5rem',
            color: colors.supplementary.white,
            cursor: 'pointer',
            marginRight: 0,
            '& span': {
                fontSize: 'inherit',
            },
        },
    },
    headingContainer: {},
    descriptionContainer: {},
}));
export default useStyles;
